import "./footer.css";

export const Footer = () => {
    return (
     <div>
        <div id="footerContainer">
                    <div class = "box1Footer">
                        <div class= "footerMediaDiv">
                            <div class="footerDiv_1">
                                <a class="paraInfoFooter">My Account</a>
                                <a class="paraInfoFooter">Email Preferences</a>
                                <a class="paraInfoFooter">International Help</a>
                                <a class="paraInfoFooter">Privacy Policy</a>
                                <a class="paraInfoFooter">Accessibility</a>
                                <a class="paraInfoFooter">Sales and Deals</a>
                            </div>
                            <div class="footerDiv_2">
                            <a class="paraInfoFooter">Terms & Conditions</a>
                            <a class="paraInfoFooter">Privacy Policy</a>
                            <a class="paraInfoFooter">*Promotion Terms</a>
                            <a class="paraInfoFooter">Return Policy</a>
                            </div>
                        </div>
                    <div class="infoDiv">
                        <a class="headInfoFooter">MY ACCOUNT</a>
                        <a class="paraInfoFooter">Orders & Returns</a>
                        <a class="paraInfoFooter">Email Preferences</a>
                        <a class="paraInfoFooter">Account Settings</a>
                    </div>
                    <div class="infoDiv">
                        <a class="headInfoFooter">LET US HELP</a>
                        <a class="paraInfoFooter">Contact Customer Care</a>
                        <a class="paraInfoFooter">Shipping Information</a>
                        <a class="paraInfoFooter">Return Policy</a>
                        <a class="paraInfoFooter">International Help</a>
                        <a class="paraInfoFooter">Accessibility</a>
                    </div>
                    <div class="infoDiv">
                        <a class="headInfoFooter">COMPANY INFORMATION</a>
                        <a class="paraInfoFooter">About Overstock™</a>
                        <a class="paraInfoFooter">Careers</a>
                        <a class="paraInfoFooter">Sell Your Products</a>
                        <a class="paraInfoFooter">Overstock™ Investor Relations</a>
                        <a class="paraInfoFooter">Overstock Dividend FAQs</a>
                        <a class="paraInfoFooter">Overstock™ Supply Chain Transparency</a>
                    </div>
                    <div class="infoDiv">
                        <a class="headInfoFooter">MORE WAYS TO SHOP</a>
                        <a class="paraInfoFooter">Tips & Ideas</a>
                        <a class="paraInfoFooter">Deals</a>
                        <a class="paraInfoFooter">Clearance</a>
                        <a class="paraInfoFooter">New Arrivals</a>
                    </div>
                    </div>
                <div class = "box2Footer">
                <a class = "mediaAnchor">Ship to:</a>
                <div class = "copyrightSec">
                    <p> © Copyright 2021, Overstock.com®, Inc.<br />799 Coliseum Way Midvale, UT 84047 | 1-800-843-2446 </p>
                </div>
                <div class = "privacySec">
                        <a>Privacy</a>
                        <a>PolicyTerms & Conditions</a>
                        <a>*Promotion Terms</a>
                        <a>Ship to:</a>
                </div>
                </div>
                </div>
                </div>
    )
    }    